import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassHowItWorks = (props: Props) => {
  const { howItWorks } = props;
  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      <BodyText sizeMatch={['16']} bold accessibilityRole="header" aria-level={2}>
        <FormattedMessage {...messages.title} />
      </BodyText>

      <BodyText sizeMatch={['16']}>{howItWorks}</BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    gap: theme.spacing['4'],
  },
  containerSM: {
    gap: theme.spacing['8'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'How it works',
    description: 'Sweetpass | Checkout | How It Works | Title',
  },
});

// ─── Props ───────────────────────────────────────────────────────────────────

type Props = {
  howItWorks: string;
};
